module.exports = __webpack_public_path__ + "img/blue.fce388c9.svg";